import { Component, Input, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NonOwnerPersonnel } from 'app/models/dto/non-owner-personnel.model';
import { DeleteNonOwnerPersonnel, UpdateNonOwnerPersonnel } from 'app/store/non-owner-personnel/non-owner-personnel.actions';
import { NonOwnerPersonnelState } from 'app/store/non-owner-personnel/non-owner-personnel.state';


@Component({
  selector: 'app-edit-non-owner-personnel-smart',
  templateUrl: './edit-non-owner-personnel-smart.component.html',
  styleUrls: ['./edit-non-owner-personnel-smart.component.scss']
})
export class EditNonOwnerPersonnelSmartComponent implements OnInit {

  @Select(NonOwnerPersonnelState.processing) processing$: Observable<{ saving: boolean, contactId: number | string }>;

  @Input() nonOwnerPersonnel: NonOwnerPersonnel;

  constructor (
    private store: Store
  ) { }

  ngOnInit(): void {}

  deleteNonOwnerPersonnel(id: number) {
    this.store.dispatch(new DeleteNonOwnerPersonnel(id));
  }

  saveNonOwnerPersonnel(nonOwnerPersonnel: NonOwnerPersonnel) {
    this.store.dispatch(new UpdateNonOwnerPersonnel(nonOwnerPersonnel));
  }

}
